import CircleQuestionMarkFilled from '../../src/legacy/CircleQuestionMarkFilled.tsx';
export default CircleQuestionMarkFilled;
